import { defineComponent as F, computed as k, ref as p, onMounted as D, nextTick as B, onUnmounted as W, watch as $ } from "vue";
import { throttle as A } from "lodash-es";
import { v as M } from "./component-library264.js";
import S from "./component-library3.js";
import U from "./component-library91.js";
const N = /* @__PURE__ */ F({
  __name: "tooltip",
  props: {
    text: { default: void 0 },
    position: { default: "auto" },
    button: { default: void 0 },
    openOnHover: { type: Boolean, default: !1 },
    openOnClick: { type: Boolean, default: !0 },
    opened: { type: Boolean, default: !1 },
    innerAriaHidden: { type: Boolean, default: !1 },
    mobileFirstTapTooltip: { type: Boolean, default: !0 }
  },
  emits: ["click"],
  setup(H, { expose: y, emit: a }) {
    const e = H, t = U(), C = k(() => ({
      tooltip: !0,
      "tooltip--open": t.isOpened.value,
      "tooltip--open-on-hover": e.openOnHover
    })), d = p(null), f = p(null), v = p("top"), T = k(
      () => e.position !== void 0 && e.position !== "auto" ? e.position : v.value
    ), s = () => {
      if (e.position !== void 0 && e.position !== "auto" || !f.value || !d.value?.$el) return;
      const o = f.value.getBoundingClientRect(), c = d.value.$el.getBoundingClientRect(), R = window.document.body.offsetWidth, x = window.document.body.offsetHeight, m = c.top, w = R - c.right, g = x - c.bottom, O = c.left, h = [
        { position: "top", space: m - o.height },
        { position: "bottom", space: g - o.height },
        { position: "left", space: O - o.width },
        { position: "right", space: w - o.width }
      ].filter((u) => u.space >= 0);
      let l = h.length > 0 ? h.reduce((u, b) => b.space > u.space ? b : u).position : "top";
      h.length === 0 && (g >= o.height ? l = "bottom" : m >= o.height ? l = "top" : w >= o.width ? l = "right" : O >= o.width && (l = "left")), v.value = l;
    }, r = A(s, 250), n = p(!1), i = p(!1);
    D(() => {
      e.opened && (t.isOpened.value = !0), B(() => {
        s();
      });
    }), W(() => {
      window.removeEventListener("resize", r);
    }), $(t.isOpened, (o) => {
      if (!o) {
        window.removeEventListener("resize", r), i.value = !1;
        return;
      }
      window.addEventListener("resize", r), B(() => {
        s();
      });
    });
    const _ = (o) => {
      if (e.openOnHover) {
        if (e.mobileFirstTapTooltip && o.pointerType === "touch") {
          if (!t.isOpened.value || !i.value) {
            o.preventDefault(), o.stopPropagation(), t.open(), i.value = !0;
            return;
          }
          a("click", o), i.value = !1, t.close();
        } else o.pointerType !== "touch" && a("click", o);
        return;
      }
      e.openOnClick && (a("click", o), n.value ? (t.close(), n.value = !1) : (t.open(), n.value = !0));
    }, E = () => {
      e.openOnHover && t.open();
    }, L = () => {
      e.openOnHover && !n.value && t.close(), i.value = !1;
    }, z = () => {
      e.openOnHover && t.open();
    }, P = () => {
      e.openOnHover && !n.value && t.close();
    };
    return y({ resizeHandler: s }), { __sfc: !0, openable: t, emit: a, props: e, containerClass: C, buttonElement: d, tooltipElement: f, calculatedPosition: v, tooltipPosition: T, resizeHandler: s, throttledResizeHandler: r, isOpendOnClick: n, mobileTooltipShown: i, click: _, mouseOver: E, mouseLeave: L, onFocus: z, onBlur: P, vOnClickaway: M.directive, LinkButton: S };
  }
});
export {
  N as default
};
